import { useMutation } from 'react-query';

import { plfAnalysis as mutationFn } from 'api/endPoints/plfAnalysis';
import { UploadXerPayload } from 'api/mutations/uploadXerFile.mutation';

export const useMutationUploadPlfFile = () => {
    return useMutation<any, QueryError, Partial<UploadXerPayload>>({ mutationFn: (params) => mutationFn(params) });
};
